/*
 * @Author: zhangguoliang
 * @Date: 2022-11-14 15:36:17
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2022-12-07 10:22:45
 */
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import microApp from "@micro-zoe/micro-app";

// 需要新打开的页面集合
const _blankUrls = ["sub4", "sub5", "sub6"];

//处理跳转
export default function jump() {
  const { menu } = useStore();
  const router = useRouter();
  return (url: string) => {
    url = url.trim();
    if (!url) {
      return;
    }
    // 处理点击导航栏跳转
    const sub = menu.find((item) => "/" + item.name === url);
    if (sub) {
      const path = sub.path.replace(/\/#/, "");
      console.log("下发到子应用的路由跳转", path + '+' + sub.name);
      microApp.setData(sub.name, { path });
      if (_blankUrls.includes(sub.name)) {
        window.open(url + sub.path);
      } else {
        router.push(url + sub.path);
      }
      return;
    }
    // 处理http(s)链接跳转，拦截host，如果属于子应用跳子应用，否则外链直接跳转
    if (url.startsWith("http")) {
      const sub = menu.find((item) => url.includes(item.jumpUrl));
      if (sub) {
        const match = url.match(/^(https?:\/\/.*?)\//);
        if (_blankUrls.includes(sub.name)) {
          window.open("/" + sub.name + url.replace(match![1], ""));
        } else {
          router.push("/" + sub.name + url.replace(match![1], ""));
        }
        return;
      }
      window.open(url);
      return;
    }
    router.push(url);
  };
}
